<template>
  <div id="journey-page" :class="[{ 'embedded': isEmbedded }]">
    <b-loading :active.sync="loading"></b-loading>
    <div class="sub-nav-bar" :style="{fontSize:todayFont}">
      <span>คิวทั้งหมดวันนี้</span>
      <span class="to-right">{{ activities | activeActivitiesLength }} คิว</span>
    </div>

    <swiper
      v-if="activities !== undefined && activities !== null && activities.length"
      :options="swiperOption"
      ref="swiper"
      @transitionEnd="slideTransitionEndHandler()"
      @reach-end="slideChangeHandler(true)"
      @slide-change="slideChangeHandler()"
    >
      <swiper-slide v-for="(act,index) in activities" :key="index" class="journey-swiper">
        <q-card-detail
          :q-type="act.qType"
          :q-sub-type="act.qSubType"
          :q-number="act.qNumber"
          :q-prefix="act.qPrefixMask || act.qPrefix"
          :q-suffix="act.qSuffixMask || act.qSuffix"
          :appoint-time="act.appointTime"
          :shift-end-hour="act.shiftEndHour"
          :service-unit-name="act.serviceUnitName"
          :service-type="act.serviceType"
          :doctor-full-name="act.doctorFullName"
          :zone-name="act.zoneName"
          :room-name="act.roomName"
          :channel="act.channel"
          :movement-type="act.movementType"
          :qNumberFont="qNumberFont"
          :qTypeFont="qTypeFont"
          :detailFont="detailFont"
        ></q-card-detail>
      </swiper-slide>
      <!-- Optional controls -->
      <div :class="['swiper-pagination',{'embedded':isEmbedded}]" slot="pagination"></div>
    </swiper>
    <div :class="[{ 'journey-card-container': isEmbedded }]">
      <q-card-status
        v-if="activities !== null && activities.length > 0"
        :case-number="activities[currentActIndex].caseNumber"
        :case-status="activities[currentActIndex].caseStatus"
        :case-message="activities[currentActIndex].caseMessage"
        :restart-time="restartTime"
        @reload="reload()"
        :class="[{ 'journey-swiper': isEmbedded }]"
      ></q-card-status>

      <q-card-to-do
        v-if="activities !== null && activities.length > 0 && activities[currentActIndex].caseDescription"
        :case-description="activities[currentActIndex].caseDescription"
        :is-show-survey="isShowSurvey"
        @open-instruction="openServiceInstruction()"
        @open-survey="openSurvey()"
        :class="[{ 'journey-swiper': isEmbedded }]"
      ></q-card-to-do>
    </div>
    <div class="q-card-footer" :style="{fontSize:hosFont}">ระบบคิวออนไลน์ {{ hospitalName }}</div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import surveyPopup from '../components/surveyPopup'
import qInstructionPopup from '../components/qInstructionPopup'
import BLoading from 'buefy/src/components/loading/Loading'
import QCardDetail from '../components/qCardDetail'
import QCardStatus from '../components/qCardStatus'
import QCardToDo from '../components/qCardToDo'

export default {
  name: 'JourneyPage',
  components: {
    QCardToDo,
    QCardStatus,
    QCardDetail,
    BLoading,
    swiper,
    swiperSlide
  },
  mounted () {
    this.isEmbedded = process.env.VUE_APP_EMBEDDED === 'true'
    if (this.isEmbedded) {
      this.qNumberFont = '7rem'
      this.qTypeFont = '3em'
      this.detailFont = '2.75rem'
      this.todayFont = '2em'
      this.hosFont = '2rem'
    }
    this.initData()
    this.reloadInterval = setInterval(() => {
      this.initData()
      this.restartTime = true
      setTimeout(() => {
        this.restartTime = false
      }, 100)
    }, this.reloadDataTime * 60 * 1000)
  },
  data () {
    return {
      // in card font
      qNumberFont: '',
      qTypeFont: '',
      detailFont: '',
      // journey page font
      todayFont: '',
      hosFont: '',
      restartTime: false,
      reloadDataTime: 5, // minute
      reloadInterval: null,
      isOpenModal: false,
      loading: true,
      swiperOption: {
        slidesPerView: 'auto',
        // spaceBetween: 15,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      currentActIndex: 0,
      allowSlideNext: true,
      timeUpdate: 0,
      isOpenServiceInstruction: false,
      justOpenPage: true,
      currentTime: 0,
      isEmbedded: false
    }
  },
  computed: {
    ...mapState(['patientName', 'activities', 'hospitalName', 'hn']),
    activityId () {
      return this.$route.params.activityId
    },
    sessionKey () {
      return this.$route.query.sessionKey || localStorage.getItem('sessionKey')
    },
    actSwiper () {
      return this.$refs.swiper.swiper
    },
    isShowSurvey () {
      const act = this.activities[this.currentActIndex]
      return (
        (act.serviceType === 'examination' &&
          [2, 3].indexOf(act.caseNumber) > -1) ||
        (act.serviceType === 'pharmacy' && [2].indexOf(act.caseNumber) > -1) ||
        (act.serviceType === 'cashier' && [2].indexOf(act.caseNumber) > -1) ||
        (act.serviceType === 'registration' && [2].indexOf(act.caseNumber) > -1)
      )
    }
  },
  filters: {
    activeActivitiesLength (activities) {
      return activities ? activities.filter(a => !['checkedOutDoctor', 'cancel', 'late'].includes(a.currentStatus)).length : 0
    }
  },
  onIdle () {
    if (process.env.VUE_APP_EMBEDDED === 'true') {
      parent.postMessage('idle-trigger', process.env.VUE_APP_POSTMESSAGE)
    }
  },
  methods: {
    ...mapMutations(['cleanupActivities']),
    ...mapActions(['getActivitiesAction']),
    initData () {
      this.loading = true
      if (this.sessionKey) {
        localStorage.setItem('sessionKey', this.sessionKey)
      }
      this.getActivitiesAction()
        .then(() => {
          if (this.justOpenPage) {
            let cardIndex = this.activities.findIndex(
              (act) => act.id === this.activityId
            )
            this.$refs.swiper.swiper.slideTo(cardIndex)
            this.justOpenPage = false
          }
          this.loading = false
          // this.updateTimeInterval()
        })
        .catch((err) => {
          if (err.data.statusCode === 401 || err.status === 401) {
            this.$router.push('/401')
          }
          this.loading = false
        })
    },
    reload () {
      // document.location.reload()
      // FIXME: slide not update
      // this.cleanupActivities()
      this.initData()
    },
    // updateTimeInterval () {
    //   this.timeUpdate = 0
    //   this.currentTime = moment()
    //   setInterval(() => {
    //     this.timeUpdate = moment().diff(this.currentTime, 'minutes')
    //   }, 1000)
    // },
    slideTransitionEndHandler () {
      if (
        this.actSwiper.activeIndex === 0 &&
        this.currentActIndex === this.activities.length - 1 &&
        this.actSwiper.isEnd === false
      ) {
        this.currentActIndex = this.currentActIndex - 1
      }
    },
    slideChangeHandler: _.debounce(function (lastSlide) {
      lastSlide = lastSlide || false
      if (lastSlide) {
        this.currentActIndex = this.activities.length - 1
      } else if (!(this.actSwiper.isEnd && this.actSwiper.activeIndex === 0)) {
        this.currentActIndex = this.actSwiper.activeIndex
      }
    }, 300),
    openSurvey () {
      this.$buefy.modal.open({
        parent: this,
        component: surveyPopup,
        props: {
          activityId: this.activities[this.currentActIndex].id,
          serviceType: this.activities[this.currentActIndex].serviceType
        }
      })
    },
    openServiceInstruction () {
      this.$buefy.modal.open({
        parent: this,
        component: qInstructionPopup,
        props: {
          instructions: this.activities[this.currentActIndex].instructions,
          serviceUnitName: this.activities[this.currentActIndex]
            .serviceUnitName
        }
      })
    }
  },
  beforeDestroy () {
    // this.cleanupActivities()
    if (this.reloadInterval !== null) {
      clearInterval(this.reloadInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
#journey-page {
  padding-top: 120px;
  &.embedded {
    padding-top: 20px;
  }
  .sub-nav-bar {
    padding: 0.25rem 1.5rem;
    font-family: "Mitr", sans-serif;
    font-weight: 300;
    color: #717171;

    .to-right {
      float: right;
    }
  }

  .q-card-footer {
    font-size: 0.75rem;
    font-family: "Mitr", sans-serif;
    /*position: absolute;*/
    /*bottom: 8px;*/
    text-align: center;
    /*width: 100%;*/
  }
}
</style>

<!-- TODO: scope only -->
<style lang="scss">
.swiper-wrapper {
  margin-left: -0.5rem;
}

.swiper-pagination {
  bottom: 0 !important;

  &.embedded {
    bottom: 5px !important;
    margin-top: -5px;
    > .swiper-pagination-bullet {
      width: 16px;
      height: 16px;
    }
  }
}

.swiper-pagination-bullet-active {
  background: #01796f !important;
}

.journey-swiper {
  margin-left: 15px;
  width: 85vw;
}

.journey-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
